// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const XCircleIcon = /* @__PURE__ */ createIcon(
  'x-circle',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0m-6.707-3.707a1 1 0 1 1 1.414 1.414L13.414 12l2.293 2.293a1 1 0 1 1-1.414 1.414L12 13.414l-2.293 2.293a1 1 0 1 1-1.414-1.414L10.586 12 8.293 9.707a1 1 0 1 1 1.414-1.414L12 10.586zM23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11',
      },
    ],
  ]
);
